/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

// var selectCallback = function(variant, selector) {

//   if (variant) {
//     $('.variant-sku').text(variant.sku);
//   }
//   else {
//     $('.variant-sku').empty();
//   }

//   self.productPage({
//     money_format: theme.moneyFormat,
//     variant: variant,
//     selector: selector,
//     translations: {
//       add_to_cart : theme.productStrings.addToCart,
//       sold_out : theme.productStrings.soldOut,
//       unavailable : theme.productStrings.unavailable
//     }
//   });
// };

// var loginButton = document.querySelector("#wholesale-login a.login");
// loginButton.onclick = function() {
// 	var subMenu = this.parentNode;
//         if (subMenu.classList.contains('open')) {
//             subMenu.classList.remove("open");
//         } else {
//             subMenu.classList.add("open");
//         }
//   	return false;
// }

const triggers = Array.from(document.querySelectorAll('[data-toggle="collapse"]'));

window.addEventListener('click', (ev) => {
  const elm = ev.target;
  if (triggers.includes(elm)) {
    const selector = elm.getAttribute('data-target');
    collapse(selector, 'toggle');
    //ev.parentNode.toggle('show');
  }
}, false);


const fnmap = {
  'toggle': 'toggle',
  'show': 'add',
  'hide': 'remove'
};
const collapse = (selector, cmd) => {
  const targets = Array.from(document.querySelectorAll(selector));
  targets.forEach(target => {
    target.classList[fnmap[cmd]]('show');
  });
}

const downloads = Array.from(document.querySelectorAll('[data-download="true"]'));

window.addEventListener('click', (ev) => {
  const elm = ev.target;
  if (downloads.includes(elm)) {
//     const download = elm.getAttribute('download');
//     var link = document.createElement('a');
//     link.href = 'https://cdn.shopify.com/s/files/1/0102/9547/6288/files/A4704-Hayley-Pewter-Black.jpg';
//     link.download = 'https://cdn.shopify.com/s/files/1/0102/9547/6288/files/A4704-Hayley-Pewter-Black.jpg';
//     document.body.appendChild(link);
//     //link.click();
//     document.body.removeChild(link);
  }
}, false);

                         
// document.addEventListener("DOMContentLoaded", function(event) {
//    var element = document.querySelector(".Collapsible__Inner.opencollapse");
// 	element.classList.remove("opencollapse");
// });

// jQuery('.Product.Product--medium .Product__Wrapper').each(function(){
//   let ProductInfoHeight = jQuery('.Product__Info').height();
//   let ProductGalleryHeight = jQuery('.Product__Gallery').height();
//   let AsideHeight = jQuery('.Product__Aside').height();
//   //jQuery('.Product__Wrapper').css('max-height', ProductGalleryHeight + AsideHeight + 1000 +"px");
//   jQuery('.Product__Wrapper').css('max-height', ProductInfoHeight + 700 + "px");
// });
